/**
 * 全站http配置
 *
 * axios参数说明
 * isSerialize是否开启form表单提交
 * isToken是否需要token
 */
import axios from 'axios';
import { isURL } from '@/util/validate';
import { Message } from 'element-ui';
const baseUrl = '';
// 默认超时时间
axios.defaults.timeout = 10000;
// 返回其他状态码
axios.defaults.validateStatus = function (status) {
  return status >= 200 && status <= 500;
};

// 跨域请求，允许保存cookie
axios.defaults.withCredentials = true;

// http request拦截
axios.interceptors.request.use(
  config => {
    if (!isURL(config.url) && config.url && !config.url.startsWith(baseUrl)) {
      config.url = baseUrl + config.url;
    }
    // headers中配置text请求
    if (config.text === true) {
      config.headers['Content-Type'] = 'text/plain';
    }
    if (config.saltValue && config.saltValue.length > 0) {
      config.headers.salt = config.saltValue;
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
// http response 拦截
axios.interceptors.response.use(
  res => {
    // 关闭 progress bar
    // 获取状态码
    const status = res.data.code || res.status;
    const message = res.data.msg || res.data.error_description || '未知错误';
    // 如果在白名单里则自行catch逻辑处理
    // 如果是401则跳转到登录页面
    // 如果请求为非200否者默认统一处理
    if (status !== 200) {
      Message({
        message: message,
        type: 'error'
      });
      return Promise.reject(new Error(message));
    }
    return res;
  },
  error => {
    return Promise.reject(new Error(error));
  }
);

export default axios;



// WEBPACK FOOTER //
// ./src/router/axios.js